<template>
    <div style="width: 100%">
        <AdminTools />
        <div class="row">
            <div class="col-md-9"><h1 class="header-title">Links logs</h1></div>
        </div>
        <loader :loading="isLoading" v-if="isLoading"></loader>
        <div class="full logs" v-if="currentLink">
            <ul class="nav nav-tabs" v-if="!isLoading">
                <li v-for="linkOrdered in linksOrdered" class="nav-item" :key="linkOrdered.id">
                    <button class="nav-link" :class="linkOrdered.id === currentLink.id ? 'active' : ''" v-on:click="changeLink(linkOrdered)">
                        <i :class="linkOrdered.direction === 'IN' ? 'fa fa-arrow-circle-down' : 'fa fa-arrow-circle-up'" aria-hidden="true"></i>
                        {{ linkOrdered.name }}
                    </button>
                </li>
            </ul>
            <section class="content_logs" :key="currentLink.id">
                <div class="row">
                    <div class="col">
                        <div class="desc">
                            <p><b>Description :</b></p>
                            <p>{{ currentLink.description }}</p>
                        </div>
                    </div>
                    <div class="col d-flex justify-content-end align-items-center" v-if="currentLink.hasCommands">
                        <ClientColorButton :inactive-color="true" v-on:click="test(currentLink)"> {{ "START EXPORT" }} </ClientColorButton>
                    </div>
                </div>
                <div class="table-responsive mt-4">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Date</th>
                                <th>File</th>
                                <th>Log</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="log in sortDesc(currentLink.applicationLinkLogs)">
                                <td class="px-3">{{ log.id }}</td>
                                <td class="px-3">{{ getDateByFormat(log.date, "DD/MM/YYYY - HH:mm") }}</td>
                                <td class="px-3">
                                    <template v-if="log.fileLink">
                                        <span class="file" @click="downloadLog(log.fileLink)">{{ getFileName(log.fileLink) }}</span>
                                    </template>
                                    <template v-else>-</template>
                                </td>
                                <td class="px-3">
                                    <ClientColorButton :inactive-color="true" @click="openModalLogContent(log.fileContent)"
                                        >See log</ClientColorButton
                                    >
                                </td>
                                <td class="px-3">
                                    <div :class="'badge badge-' + getBadge(log.status)">
                                        <span>{{ log.status }}</span>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <LogContent v-if="paramsModalLogContent" :params="paramsModalLogContent" @close="paramsModalLogContent = null"></LogContent>
            </section>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.header-title {
    color: #6f6f6f;
    font-size: 30px;
    margin: 0 0 30px;
    text-transform: uppercase;
    font-family: "Oswald", sans-serif;
    font-weight: normal;
    display: block;
}
.logs {
    ul.nav {
        width: 100%;
        button {
            background-color: transparent;
            display: block;
            font-size: 16px;
            padding: 15px;
            color: #495057;
            font-weight: 600;
            &.active {
                background-color: white;
            }
            &:focus {
                outline: none;
            }
        }
    }

    .content_logs {
        background-color: white;
        padding: 50px 20px 50px;
    }

    table {
        margin-top: 25px;
        border-collapse: collapse;
        tr {
            td {
                text-align: center;
                padding: 15px 10px;
                vertical-align: middle;
                overflow-wrap: break-word;
                color: black;
                font-size: 19px;
                line-height: 20px;
                transition: 0.3s ease-in-out;
                font-weight: 500;
                span.file {
                    text-transform: initial;
                    cursor: pointer;
                    font-size: 19px;
                    color: black;
                    text-decoration: underline;
                    text-decoration-color: black;
                }
                .badge {
                    border-radius: 4px;
                    span {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        padding: 10px 0;
                        width: 90px;
                    }
                }
            }

            th {
                font-family: "Oswald", sans-serif;
                font-size: 19px;
                background: #343434;
                border: #343434 1px solid;
                color: #fff;
                text-transform: uppercase;
                text-align: center;
                vertical-align: center;
                padding: 15px 10px;
                font-weight: normal;
                @media (max-width: 1440px) {
                    font-size: 16px;
                }
            }
        }
    }
}
</style>

<script>
import AdminTools from "../../adminTools/Admin";
import TryLoad from "@/mixins/TryLoadMixin";
import loader from "@/components/loader/loader";
import { LOG_STATUS } from "@/components/admin/logs/constants";
import Globals from "@/components/globals";
import Axios from "axios";
import LogContent from "@/components/admin/logs/LogContent";
import applicationLinkService from "@/services/applicationLink";
import http from "@/services/http";
import { buildUrlFromLocation } from "@/utils/httpUtils";

export default {
    data: () => ({
        links: [],
        link: null,
        isLoading: false,
        modalEditProfile: null,
        modalCreateProfile: null,
        paramsModalLogContent: null
    }),
    components: {
        LogContent,
        AdminTools,
        loader
    },
    mixins: [TryLoad],
    async created() {
        this.isLoading = true;
        await this.loadApplicationLinks();
        this.isLoading = false;
        if (this.links.length > 0) {
            this.link = this.links[0];
        }
    },
    methods: {
        changeLink(newLink) {
            this.link = newLink;
        },
        getBadge(status) {
            switch (status) {
                case LOG_STATUS.SUCCESS:
                    return "success";
                case LOG_STATUS.WARNING:
                    return "warning text-white";
                default:
                    return "danger";
            }
        },
        getFileUrl(fileLink) {
            return Globals.getBaseUrl() + fileLink;
        },
        getFileName(fileLink) {
            const split = fileLink.split("/");
            return split[split.length - 1];
        },
        downloadLog(fileLink) {
            const axios = Axios.create();
            axios.get(this.getFileUrl(fileLink), { responseType: "arraybuffer" }).then(res => {
                let blob = new Blob([res.data], { type: "application/*" });
                let link = document.createElement("a");
                link.href = window.URL.createObjectURL(blob);
                link.download = this.getFileName(fileLink);
                link._target = "blank";
                link.click();
            });
        },
        openModalLogContent(logContent) {
            this.paramsModalLogContent = {
                logContent: logContent,
                isActive: true
            };
        },
        async loadApplicationLinks() {
            this.links = await this.tryLoad(() => http.get(buildUrlFromLocation(`/admin/applications-import-export`, { campaignId: null })));
        },
        test(applicationLink) {
            this.isLoading = true;
            http.get(buildUrlFromLocation(`/admin/applications-import-export/${applicationLink.id}/execute`, { campaignId: null }))
                .then(() => {
                    this.loadApplicationLinks().then(() => {
                        this.dialogSuccess();
                        this.isLoading = false;
                    });
                })
                .catch(() => {
                    this.dialogError();
                    this.isLoading = false;
                });
        },
        sortDesc(array) {
            return array.slice().reverse();
        }
    },
    computed: {
        linksOrdered() {
            return this.links.sort((link1, link2) => {
                return link1.direction <= link2.direction && link1.name <= link2.name ? -1 : 1;
            });
        },
        currentLink() {
            return this.link;
        }
    }
};
</script>



// WEBPACK FOOTER //
// Logs.vue?4583bbaa